import GATracking from './ga-tracking-id-config.json'

/**
 * Config file to load settings
 * 
 */
const getActiveEnvironment = () => {
  //if (window.location.hostname in hostEndpoints) {
  if (window.location.hostname.indexOf('localhost') > -1) return 'localhost';
  if (window.location.hostname.indexOf('kb-dev') > -1) return 'dev';
  if (window.location.hostname.indexOf('sqa.npr') > -1) return 'sqa';
  if (window.location.hostname.indexOf('uat.npr') > -1) return 'uat';
  if (window.location.hostname.indexOf('stg.faq.ntsupport.docomo.ne.jp') > -1) return 'prod';
  if (window.location.hostname.indexOf('faq.ntsupport.docomo.ne.jp') > -1) return 'prod';
  return 'dev';

  /*  } else {
     return window.location.hostname;
   } */
}

// uncomment on prod/dev/uat/sqa and comment on local
const config = {
   endpoints: {
     "api": "/api"
   },
   env: getActiveEnvironment(),
   loginURL: "/api/login"
}


// do comment on local and comment the above one
// const config = {
//   endpoints: {
//     "api": "http://localhost:3000"
//   },
//   env: getActiveEnvironment(),
//   loginURL: "http://localhost:3000/login"
// }

// Get tracking ID for different environment
const trackingId = GATracking[getActiveEnvironment() === 'localhost' ? 'dev' :  getActiveEnvironment()].trackingId

export { config, trackingId };